import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

Vue.config.devtools = true;

import uxModule from "./Modules/uxModule";
import sharedModule from "./Modules/sharedModule";
import securityModule from "./Modules/securityModule";
import filesModule from "./Modules/filesModule";
import assessmentsModule from "./Modules/assessmentsModule";
import appointmentsModule from "./Modules/appointmentsModule";
import optionsModule from "./Modules/optionsModule";
const state = {};

const mutations = {};

const actions = {};

const store = new Vuex.Store({
  modules: {
    uxModule: uxModule,
    sharedModule: sharedModule,
    securityModule: securityModule,
    assessmentsModule: assessmentsModule,
    filesModule: filesModule,
    appointmentsModule: appointmentsModule,
    optionsModule: optionsModule,
  },

  state,
  mutations,
  actions,
  //plugins: [
  //  createPersistedState({
  //    storage: window.sessionStorage,
  //  }),
  //],
});

export default store;
